import styled from 'styled-components';

import { Box } from '@mui/material';

export const Wrapper = styled.div`
  min-height: 100vh;
`;

export const TabsContainer = styled(Box)`
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.palette.divider};
  background: ${({ theme }) => theme.palette.common.white};
  overflow-y: auto;
`;
